<template>
    <div>
        <loading v-if="currentState === 0"></loading>

        <div v-if="currentState === 1">
            <app-header :closeable="true" :title="'choose a nick name'"></app-header>

            <section class="container">
                <div class="intro-content pt--40 pb--40">
                    <img src="/img/logo-title.png" alt="" class="intro-content__logo" />
                </div>

                <div class="mb--lg">
                     <input type="text" v-model="nick" :placeholder="placeholder" @keyup.enter="chooseNick" class="form-control mb--md">
                    <button type="button" @click="chooseNick" class="btn btn--block btn--primary">Next</button>
                </div>

                <p class="text--center text--xs opacity--md">
                    <strong>No registration required.</strong>
                </p>
            </section>
        </div>

        <modal ref="alertModal" type="error" show="false">
            <template></template>
            <template v-slot:message>
                Initialization failed: room with code <b>{{ code }}</b> not found!
            </template>
        </modal>

        <modal ref="validationModal" type="error" show="false">
            <template v-slot:message>
                This username '{{ nick}}' is already in use. Please choose another one.
            </template>

            <template v-slot:buttons>
                <span></span>has
            </template>
        </modal>
    </div>
</template>

<script>
    import api from '../../../api/scholar'
    import {mapState, mapGetters} from 'vuex'
    import AppHeader from "../../partial/AppHeader";

    export default {
        components: {AppHeader},
        props: {
            code: {
                required: true
            }
        },

        data: function () {
            return {
                waitForConnection: null,
                suggestedNick: '',
                nick: '',
                currentState: 0,
            }
        },

        methods: {
            checkCode() {
                if (! this.code) {
                    return;
                }

                api.findRoom(this.code).then((response) => {
                    if (this.isLoggedIn) {
                        this.subscribe('scholar-' + this.code, {
                            nick: this.user.nick,
                        })
                    } else {
                        this.suggestedNick = response.data.suggestedNick
                        this.currentState = 1
                    }
                }).catch( (error) => {
                    this.$refs.alertModal.open()
                })
            },

            chooseNick() {
                this.subscribe('scholar-' + this.code, {
                    nick: this.nick,
                })
            },

            goToMatchMaking() {
                this.$router.push('/game/scholar-multiplayer/' + this.code)
            }
        },

        computed: {
            ...mapState('websocket', [
                'isConnected'
            ]),

            ...mapGetters('auth', [
                'user',
                'isLoggedIn',
            ]),

            placeholder() {
                if (! this.suggestedNick) {
                    return ''
                }

                return 'e.g. ' + this.suggestedNick
            }
        },

        created() {
            this.waitForConnection = setInterval(() => {
                if (this.isConnected) {
                    clearInterval(this.waitForConnection)
                    this.checkCode()
                }
            }, 1000)

            Quiz.$on('pusher_internal:subscription_succeeded', () => {
                    this.goToMatchMaking()
            })

            Quiz.$on('scholar-nick-not-allowed', (message) => {
                if (message.data.channel === 'scholar-' + this.code) {
                    this.$refs.validationModal.open()
                }
            })
        },

        beforeDestroy() {
            if (this.room) {
                this.unsubscribe('scholar-' + this.room.id)
            }
            Quiz.$off('scholar-nick-not-allowed')
            Quiz.$off('pusher_internal:subscription_succeeded')
        }
    }
</script>